import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

// Mirrors assets/product-inventory.js: the section is re-rendered on variant
// change and we morph in the new markup, so the ETA always matches the size the
// shopper currently has selected.
class BrainDeliveryEta extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(ThemeEvents.variantUpdate, this.updateEta);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.updateEta);
  }

  updateEta = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const next = event.detail.data.html.querySelector('brain-delivery-eta');
    if (!next) return;

    morph(this, next, { childrenOnly: true });
  };
}

if (!customElements.get('brain-delivery-eta')) {
  customElements.define('brain-delivery-eta', BrainDeliveryEta);
}
